import * as React from 'react';

import { Link } from 'react-router-dom';

import { LinkBlockItemActive } from '@app/objects/LinkBlockItem';
import { eventToLink } from '@app/components/LocalCommon/Utils/eventToLink';

export const petLossGroupLinkItems: LinkBlockItemActive[] = [
	{
		path: '/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
	},
	{
		path: '/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
	},
	{
		path: '/our-services/aftercare',
		name: 'Aftercare',
	},
	{
		path: '/our-services/telehospice',
		name: 'Telehospice',
	},
	{
		path: '/our-services/pet-loss-support',
		name: 'Pet Loss Support',
		active: true,
	},
];

export const navItems = [
	{
		name: 'journey',
		title: 'Pet Loss Journey Course',
	},
	{
		name: 'personal',
		title: 'Personal Support',
	},
	{
		name: 'group',
		title: 'Support Group',
	},
	{
		name: 'keepsakes',
		title: 'Pet Memorial Keepsakes',
	},
];

export const petLossGroupText = (
	<>
		<p>
			Many loving pet parents feel alone when their beloved pet dies. Lap of Love is honored to walk with you in your grief journey and invites
			you to attend our free Pet Loss Support Group. The support group provides a safe, compassionate, and empathetic environment for those who
			want to listen, share, and celebrate the life of their treasured pet with others who are suffering a similar loss. Sessions are available
			several times throughout the week virtually via Zoom and are led by Lap of Love’s dedicated Pet Loss Support team. Anyone who has
			experienced the death of a pet is welcome to attend.
		</p>
		<p>
			The groups will focus on healthy coping skills, grief reactions, and honoring the lives of your furry family member. If you are struggling
			with feeling alone in your grief journey, Lap of Love’s virtual Pet Loss Support Groups are here to help you.
		</p>
		<p>
			In addition to these sessions, we also offer virtual support groups tailored specifically those experiencing anticipatory grief and one
			for those who have experienced the pain of behavioral euthanasia. Please click the link below to see the upcoming schedule for these
			sessions.
		</p>
	</>
);

export const armsOfLoveText = (
	<>
		<p>
			This 6-week course is designed for pet parents who wish to have an additional level of knowledge and support surrounding the death of
			their pet. The curriculum is designed in an educational format, with each session developed around specific aspects surrounding the loss
			of a beloved pet. Understanding the Pet Loss Journey Course will be held via Zoom and occur weekly for 1 hour. Please see below for the
			course dates and times offered. The entire course curriculum was built specifically for Lap of Love by pet loss pioneer, Coleen Ellis, and
			is presented by one of our dedicated Pet Loss Support team members. Attendees to Understanding the Pet Loss Journey sessions will have an
			opportunity to learn more about their loss, with reflection activities recommended between each session to assist each individual in their
			grief journey.
		</p>
		<p>Course Agenda:</p>
		<p>
			Week 1: Why does this loss hurt so bad?
			<br />
			Week 2: What can I do to help myself through this loss? The six central needs of mourning.
			<br />
			Week 3: How can I help my children and pets?
			<br />
			Week 4: Why do I feel so guilty, sad, and angry?
			<br />
			Week 5: The year of “1sts” and other pivotal moments in the grief journey.
			<br />
			Week 6: Rituals for honoring the life shared with a beloved pet.
			<br />
		</p>
		<p style={{ fontStyle: 'italic' }}>Cost: $149.00 for the 6-week course</p>
		<a
			href="https://petlosssupportgroupschedule.as.me/schedule.php?appointmentType=category%3ACurriculum"
			className="inline-link midnightblue"
			target="_blank"
		>
			Register for the Arms of Love - Understanding the Pet Loss Journey 6-Week Curriculum Course
		</a>
		<p style={{ fontStyle: 'italic' }}>
			*This program is non-refundable and is limited to 10 participants per six weeks to allow an intimate group setting with open dialogue at
			the end of each session.
		</p>
	</>
);

export const individualSessionText = (
	<>
		<p>
			Grieving the loss of a pet is a very personal experience and the journey to healing is different for everyone. Our individual support
			sessions are for pet parents who desire personalized support on how to heal following the death of their beloved pet. Individual call
			sessions are led by a Pet Loss Support team member who will offer a compassionate ear and a caring safe space for the sharing of feelings
			and emotions surrounding the death of a loved pet.
		</p>
		<p style={{ fontStyle: 'italic' }}>Cost: $50.00 for a 50-minute session</p>
		<a
			href="https://petlosssupportgroupschedule.as.me/schedule.php?appointmentType=category%3AOne+on+One"
			className="inline-link midnightblue"
			target="_blank"
		>
			Schedule an Individual Pet Loss Support Session
		</a>
		<p style={{ fontStyle: 'italic' }}>
			* Individual support calls will not take the place of a licensed mental health counselor. They will be run on a “companioning” model,
			which provides support to the caller, not counseling. Callers will be provided with additional counseling service referrals if requested.
		</p>
	</>
);

export const petLossGroupJoinText = (
	<>
		<p>
			<b>
				<i>Cost: Free!</i>
			</b>
		</p>
		<a
			className="inline-link midnightblue"
			href="https://petlosssupportgroupschedule.as.me/schedule.php?appointmentType=category%3ASupport+Group"
			target="_blank"
		>
			<b>Reserve my spot in a Pet Loss Support Group session</b>
		</a>
	</>
);

export const petMemorialKeepsakesText = (
	<>
		<p>
			When your pet is no longer physically present, keeping their memory alive through a memento or keepsake can both honor them and help ease
			the grieving process. Whether it’s a painting of your pet or a necklace made from their pawprint, an object that you can hold in your hand
			creates a sense of everlasting connection.
		</p>
		<p>
			Our Pet Memorial Keepsakes site was created for those who seek comfort in mementos after saying goodbye to a pet. The site offers a range
			of unique memorial items from carefully selected companies. We hope you find an item that perfectly symbolizes the forever bond between
			you and your beloved friend.
		</p>
		<p>
			<a
				href="https://info.lapoflove.com/keepsakes"
				target="_blank"
				rel="nofollow noreferrer"
				className="inline-link midnightblue"
			>
				<b>View Keepsakes</b>
			</a>
		</p>
	</>
);

export const disclaimerTitle = 'MENTAL HEALTH DISCLAIMER:';
export const disclaimerText = (
	<>
		<p>
			<i>
				The loss of an animal companion can lead to challenging emotional responses that warrant professional mental health support which is
				beyond the scope and training of the Lap of Love Pet Loss Resource Line staff. While we are here to provide compassionate grief
				support, we are unable to appropriately evaluate human mental health concerns and do not provide mental health counseling. The
				services of the Pet Loss Resource Line are not intended to directly support or provide a substitute for definitive mental health care,
				especially in a crisis. We may be able to help you find pet loss support resources in your area, but we cannot provide referrals to
				specific mental health services.
			</i>
		</p>
		<h3 className="rich-text__title">
			If you or someone you’re concerned about is depressed, unable to cope, or having thoughts of self-harm or harming others, IMMEDIATELY call
			the 988 Suicide & Crisis Lifeline by dialing 988 or call your local non-emergency resource center. For emergency services, please dial
			911.
		</h3>
	</>
);
export const disclaimerAddText = (
	<>
		<h3 className="rich-text__title">Additional emergency and crisis services include:</h3>
	</>
);

export const emergencyService = [
	{
		url: 'https://988lifeline.org',
		title: 'The 988 Suicide & Crisis Lifeline',
		description: (
			<>
				Call or text the 3-digit nationwide code:{' '}
				<b>
					<a href="tel:988">988</a>
				</b>
				<br />
				Online chat:{' '}
				<b>
					<a href="https://988lifeline.org">988lifeline.org</a>
				</b>
				<br />
				24/7, free, confidential support for people in distress. Prevention and crisis resources.
			</>
		),
	},
];
export const additionalServices = [
	{
		url: 'http://www.suicide.org/suicide-hotlines.html',
		title: 'Suicide Hotline Numbers by State',
		description: 'Suicide prevention, awareness, and support',
	},
	{
		url: 'https://www.crisistextline.org/',
		title: 'Crisis Text Line',
		description:
			'Text HOME to 741741 from anywhere in the United States, anytime, about any type of crisis. A live, trained Crisis Counselor receives the text and responds from the Crisis Text Line’s secure online platform.',
	},
	{
		url: 'https://nami.org/Home',
		title: 'National Alliance on Mental Illness (NAMI)',
		description: (
			<>
				<a href="tel:8009506264">800-950-6264</a>
				<br />
				Text NAMI to 741741
				<br />
				Confidential, free crisis counseling
			</>
		),
	},
	{
		url: 'https://www.211.org/',
		title: '211',
		description: 'Call 211 to get immediate, expert help and also to find on-going local support.',
	},
	{
		url: 'https://www.veteranscrisisline.net/',
		title: 'Veterans Crisis Line',
		description: (
			<>
				<a href="tel:8002738255">800-273-8255</a> (TALK), Press 1 or text 838255
				<br />
				24/7 service for veterans and their loved ones
			</>
		),
	},
	{
		url: 'https://www.thetrevorproject.org/',
		title: 'The Trevor Project',
		description: (
			<>
				<a href="tel:8664887386">866-488-7386</a> or text START to 678678
				<br />
				24/7 crisis and suicide prevention services to LGBTQ+ people
			</>
		),
	},
	{
		url: 'https://www.listenersoncall.com/',
		title: 'Listeners on Call',
		description: (
			<>
				Connect anyone, anywhere, anytime with someone who has a related personal experience and is ready to listen. Visit their site for
				pricing information and to download their app.
			</>
		),
	},
	{
		url: 'https://nationaldepressionhotline.org/',
		title: 'National Depression Hotline',
		description: (
			<>
				<a href="tel:8666294564">866-629-4564</a>
				<br />
				Free 24/7 nationwide hotline for people struggling with depression and post-traumatic stress disorder.
			</>
		),
	},
];
